import { makeAutoObservable } from 'mobx';

import {cmApi } from '@src/api';
import type { CmApi} from '@src/api';

import { preloaderStore } from '../preloaderStore';

class ReportingFormFiveStore {
  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  getColumns = async (tableName: string) => {
    let columns = [];
    preloaderStore.preloader(true);
    try {
      const result = await this.api.tableMetaData.getTableMetaData({
        resource: tableName,
      });

      if (!!result.data)
        columns = Array.isArray(result?.data?.columnsMetaData)
          ? result?.data?.columnsMetaData?.map((item) => ({
              columnComment: item.columnComment ?? '',
              columnName: item.columnName ?? '',
              dataType: item.dataType ?? '',
              displaySign: item.displaySign,
              drillDownSign: item.drillDownSign,
              orderNo: item.orderNo,
              isSummation: item.isSummation,
              disclosureReportVersionCode: !!result?.data?.disclosureReportVersionCodes?.length
                ? result?.data?.disclosureReportVersionCodes[0]
                : null,
            }))
          : [];
      preloaderStore.preloader(false);
      return { ...result.data, columns };
    } catch (error) {
      console.error(error);
      preloaderStore.preloader(false);
      return { columns };
    }
  };
}

export const reportingFormFiveStore = new ReportingFormFiveStore({ api: cmApi });
